import { Routes, Route, Navigate } from 'react-router-dom'
import OrganizationDetailsPage from './pages/organization-details'

export default function SettingsPage() {
  return (
    <Routes>
      <Route path="/organization-details" element={<OrganizationDetailsPage />} />
      <Route path="/" element={<Navigate to="/settings/organization-details" />} />
    </Routes>
  )
}
